import { render, staticRenderFns } from "./SalariesTabs.vue?vue&type=template&id=67935cc5"
import script from "./SalariesTabs.vue?vue&type=script&lang=js"
export * from "./SalariesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports